// extracted by mini-css-extract-plugin
export default {"container":"AA-z","dimension":"BA-z","dimensionLabels":"CA-z"};